import {
  Alert,
  Box,
  Button,
  Container,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../api/authService";
import { useAuth } from "../../contexts/AuthContext";
import { useForm } from "react-hook-form";

const LoginForm = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // Bootstrap registration is only offered while no admin account exists.
  const [registrationOpen, setRegistrationOpen] = useState(false);

  const { login, sessionExpired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    AuthService.isRegistrationOpen()
      .then((open) => {
        if (!cancelled) setRegistrationOpen(open);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const onSubmit = async (data) => {
    // Reset error
    setError("");

    try {
      setLoading(true);
      await login(data);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Invalid username or password");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper
        elevation={3}
        sx={{
          marginTop: 8,
          padding: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Admin Login
        </Typography>

        {sessionExpired && !error && (
          <Alert severity="info" sx={{ mt: 2, width: "100%" }}>
            Your session has expired. Please log in again.
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2, width: "100%" }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 3 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            autoComplete="username"
            autoFocus
            error={!!errors.username}
            helperText={errors.username?.message}
            {...register("username", {
              required: "Username is required",
            })}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            error={!!errors.password}
            helperText={errors.password?.message}
            {...register("password", {
              required: "Password is required",
            })}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
          {registrationOpen && (
            <Box sx={{ textAlign: "center", mt: 2 }}>
              <Link href="/admin/register" variant="body2">
                Need to create the first admin account? Register here
              </Link>
            </Box>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default LoginForm;
